import { Box, Button, Dialog, Slide, Typography } from "@mui/material";
import React, { forwardRef } from "react";
import ReportIcon from "@mui/icons-material/Report";

const Transition = forwardRef(function Transition(props, ref) {
	return <Slide direction="up" ref={ref} {...props} />;
});

export default function ConfirmModal({ 
  title, 
  modalText, 
  headerVariant = "h5", 
  textVariant = "subtitle1", 
  textWeight = "normal",
  confirmText = "Yes",
  cancelText = "No",
  open, 
  handleClose,
  isWarningModal = false,
  entityName = "",
  entityDesc = ""
}) {

  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
    >
      <Box 
        component="div" 
        flexWrap="wrap" 
        sx={{
          display: "flex", 
          flex: "1 0 100%", 
          justifyContent: "center", 
        }}
      >
        <Box
          sx={{
            backgroundColor: isWarningModal ? "#ac0a00" : "var(--tealColor)",
            width: "100%",
            padding: ".5rem"
          }}
        >
          <Typography 
            variant={headerVariant} 
            textAlign="left" 
            fontSize="1.5rem" 
            fontWeight="bold" 
            sx={{ 
              marginLeft: ".5rem", 
              display: "block", 
              width: "100%", 
              color: "#FFF"
            }}
          >
            {title ?? ""}
          </Typography>
        </Box>
        <Box
          sx={{
            padding: ".5rem",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "nowrap"
          }}
        >
          {isWarningModal ? (
            <>
              <p>
                <ReportIcon sx={{fontSize: "5rem", color: "#ac0a00", margin: ".5rem"}}/>
              </p>
              <Typography
                whiteSpace="pre-wrap"
              >
                <b>Are you sure you want to remove {entityName}?</b> {'\n\n'}
                This will remove {entityDesc}. You can&apos;t undo this action.
              </Typography>
            </>
          ) : (
            <Typography 
              variant={textVariant} 
              fontWeight={textWeight} 
              textAlign="center" 
              sx={{
                width: "100%",
                whiteSpace: "pre-wrap"
              }}
            >
              {modalText}
            </Typography>
          )}
        </Box>
        <Box
          sx={{
            padding: "1rem 0",
            borderTop: "1px solid lightgray",
            width: "100%",
            display: "flex",
            justifyContent: "center"
          }}
        >
          <Button 
            sx={{
              justifySelf: "center", 
              fontWeight: "bold", 
              backgroundColor: "var(--yellowColor)",
              color: "#000"
            }} 
            variant="contained"
            onClick={() => handleClose(false)}
          >
            {cancelText}
          </Button>
          <Button 
            sx={{
              justifySelf: "center", 
              marginX: "1rem", 
              fontWeight: "bold", 
              backgroundColor: isWarningModal ? "#ac0a00" : "var(--tealColor)"
            }} 
            variant="contained" 
            onClick={() => handleClose(true)}
          >
            {confirmText}
          </Button>
        </Box>
      </Box>
  </Dialog>
  )
}